import React from 'react';
import clsx from 'clsx';

const VotingCard = (props: { name: string; className?: string }) => {
  const { name, className } = props;

  return (
    <div
      className={clsx(
        'w-[80%] rounded-lg bg-white p-[2%]',
        className && className
      )}
      style={{ boxShadow: '0px 59px 150px rgba(187, 196, 204, 0.25)' }}
    >
      <picture className="relative w-full">
        <source
          srcSet={`${require(`@assets/images/marketplace/voting-home/${name}.webp`)} 1x, ${require(`@assets/images/marketplace/voting-home/${name}@2x.webp`)} 2x, ${require(`@assets/images/marketplace/voting-home/${name}@3x.webp`)} 3x`}
          type="image/webp"
        />
        <img
          className="w-full"
          src={require(`@assets/images/marketplace/voting-home/${name}.png`)}
          alt="thumb-up"
        />
      </picture>
    </div>
  );
};

const VotingCards = () => {
  return (
    <div
      className={clsx(
        'mt-7 flex aspect-square justify-center self-center',
        'w-full max-w-[580px]',
        'sm:mt-9',
        'lg:mt-[0px] lg:w-[47%]'
      )}
    >
      <div
        className={clsx(
          'relative mt-[-5%] flex h-full w-full flex-row justify-end'
        )}
      >
        <VotingCard name="nurul" className="relative mt-[10%] self-start" />
        <img
          src={require('@assets/images/marketplace/voting-home/josias.svg')}
          alt="josias"
          className="absolute left-[0px] top-[8%] z-10 w-[80%] scale-[1.7]"
        />
      </div>
    </div>
  );
};

export { VotingCards };
